var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"returnBookdropView"},[_c('return-bookdrop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }